import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-product-support-material',
  templateUrl: './product-support-material.component.html',
  styleUrls: ['./product-support-material.component.scss']
})
export class ProductSupportMaterialComponent implements OnInit {
  @Input() data: any;

  ngOnInit(): void {
    this.data.support_materials = [
      {
        name: 'Folder sobre detalhes do imóvel',
        type: 'pdf',
        url: 'https://camara.fgv.br/sites/camara.fgv.br/files/artigos/teste33_0_3.pdf',
        description: 'Folder de lançamento comm informações iniciais sobre o empreendimento'
      },
      {
        name: 'Autorização',
        type: 'pdf',
        url: 'https://camara.fgv.br/sites/camara.fgv.br/files/artigos/teste33_0_3.pdf',
        description: 'Folder de lançamento comm informações iniciais sobre o empreendimento'
      }
    ];
  }

}
